import i18n from "i18n";
import * as yup from "yup";

export const securityGroupManagementSchema = yup.object().shape({
  securityGroup: yup
    .string()
    .required(i18n.t("securityGroupManagement.securityGroupReqError"))
});
